import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import Driver from './Drivers/Driver/Driver';
import Customer from './Customers/Customer/Customer';
import Freight from './Freights/Freight/Freight';
import Operator from './Operators/AddOrEdit/AddOrEdit';

const User = () => {
  const { role } = useParams();
  return (
    <Fragment>
      {role === 'driver' ? <Driver /> : null}
      {role === 'customer' ? <Customer /> : null}
      {role === 'freight' ? <Freight /> : null}
      {role === 'admin' ? <Operator /> : null}
    </Fragment>
  );
};

export default User;
